import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Autocomplete from "react-google-autocomplete";
import { Link } from "react-router-dom";
import styled from "styled-components";
import HomeArrow from "../assets/arrow.png";
import tooltip from "../assets/tooltip.svg";
import triangle from "../assets/Triangle.png";
import {
  AppDownload,
  Footer,
  FormInpt,
  Header2,
  HomeOfferSlider,
  HomeWork,
  OurOffer,
  ProductCoverd,
  ProductCoverdSec
} from "../components";
import { Send } from "../helper";

const HomePage = () => {
  const [pickup, setPickup] = useState("");
  const [drop, setDrop] = useState("");
  const [vehicle, setVehicle] = useState("");
  const [loading, setLoading] = useState(true);
  const [cities, setCities] = useState([]);
  const [otype, setoType] = useState("");
  const [activeCity, setActiveCity] = useState("");
  const [EstimatedValue, setEstimatedValue] = useState("");
  const [estimating, setEstimating] = useState(false);

  const Init = async () => {
    let res = await Send("get", "/home/cities");
    if (res.type === "success") {
      let x = [];
      let i = 0;
      for await (let c of res.cities) {
        x.push({
          value: c._id,
          text: c.name,
        });
        i++;
      }
      setCities(x);
      setActiveCity(x[0].value);
      setoType("No Rush");
      setLoading(false);
    } else {
      alert(res.msg);
    }
  };
  useEffect(() => {
    Init();
  }, []);
  const ChangeActiveCity = (e, { value }) => {
    setActiveCity(value);
  };
  const Estimate = async (vehiclex, type) => {
    if (
      !vehiclex ||
      vehiclex === "" ||
      vehiclex === undefined ||
      vehiclex === null
    ) {
      vehiclex = vehicle;
    }
    if (!pickup.formatted_address) {
      alert("Please select pickup location from the dropdown");
    } else if (!drop.formatted_address) {
      alert("Please select drop location from the dropdown");
    } else if (activeCity === "" || drop === "" || pickup === "") {
      alert("Please fill all the fields.");
    } else if (vehiclex === "") {
      return;
    } else {
      try {
        setEstimating(true);
        let res = await Send("post", "/home/estimate", {
          city_id: activeCity,
          type,
          vehicle: vehiclex,
          drop: JSON.stringify(drop),
          pick: JSON.stringify(pickup),
        });
        if (res.type === "error") {
          alert(res.msg);
        } else {
          setEstimatedValue(res.fare);
        }
        setEstimating(false);
      } catch (e) {
        alert(e.message);
        setEstimating(false);
      }
    }
  };
  const ChangeVehicle = (vehicle) => {
    if (activeCity === "" || drop === "" || pickup === "") {
      return;
    } else {
      setVehicle(vehicle);
      Estimate(vehicle, otype);
    }
  };

  return (
    <>
      <Header2 />
      <Wrapper>
        <div className="homemain">
          <Container>
            <Row className="home__hero">
              <Col sm={12} md={6}>
                <div className="hero__left">
                  <div className="hero__delivery_fees">
                    <button>New</button> <h5>We’ve reduced delivery fees.</h5>
                  </div>
                  <div className="home__hero_left">
                    <h1>Focus on other stuff we've got delivery covered</h1>
                    <p>
                      Choose Rush as your reliable delivery partner, and focus
                      on what is important.
                    </p>
                    <div className="home__hero_btn">
                      <Link
                        onClick={() =>
                          window.open(
                            "https://app.wecanrush.com/register",
                            "_blank"
                          )
                        }
                      >
                        <button>Create a free account</button>
                      </Link>

                      <button className="home__hero_btn2">
                        <img src={triangle} alt="tringle" /> Watch the Video
                      </button>
                    </div>
                  </div>
                </div>
              </Col>

              <Col sm={12} md={6} className="hone__right__form">
                <div className="home__right__wrap">
                  <form className="sign__up_form">
                    <h1>ESTIMATE</h1>

                    <div className="signUp__name">
                      <Autocomplete
                      apiKey = "AIzaSyC5rjqJrrmSWvYMexCPHbo1f-603Yg-gso"
                        onChange={(e) => setPickup(e.target.value)}
                        // onBlur = {()=>Check("pickup")}
                        value={pickup.formatted_address}
                        className="input-force fh input_value"
                        onPlaceSelected={(place) => {
                          setPickup(place);
                        }}
                        placeholder="Enter pickup location"
                        options={{
                          types: ["geocode", "establishment"],
                        }}
                        // bounds = {activeCity.lat+","+activeCity.long}
                        // location = {activeCity.lat+","+activeCity.long}
                        // radius = "2000"
                        // strictbounds = {true}
                      />
                      {/* <input type="text" placeholder="Pick Up Location" /> */}
                      <Autocomplete
                      apiKey = "AIzaSyC5rjqJrrmSWvYMexCPHbo1f-603Yg-gso"
                        onChange={(e) => setDrop(e.target.value)}
                        // onBlur = {()=>Check("drop")}
                        value={drop.formatted_address}
                        className="input-force fh"
                        onPlaceSelected={(place) => {
                          setDrop(place);
                        }}
                        options={{
                          types: ["geocode", "establishment"],
                        }}
                        placeholder="Enter drop location"
                        // bounds = {activeCity.lat+","+activeCity.long}
                        // location = {activeCity.lat+","+activeCity.long}
                        // radius = "2000"
                        // strictbounds = {true}
                      />
                    </div>

                    <div className="header__vhecel_info">
                      <FormInpt
                        ValueChanged={(value) => ChangeVehicle(value)}
                      />
                    </div>
                    <div className="estimate__tooltip">
                      <div className="estimate__price">
                        {EstimatedValue === "" ? (
                          estimating ? (
                            <>
                              <br />
                              <Spinner animation="border" />
                            </>
                          ) : null
                        ) : (
                          <>
                            {/* <strong className="big-text">
                              Estimated Price
                            </strong> */}

                            <strong className="active-color big-text">
                              $
                              {EstimatedValue.toString().replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              )}
                            </strong>
                          </>
                        )}
                      </div>

                      <div class="tooltips">
                        <img src={tooltip} alt="tooltip" />
                        <span class="tooltiptext">
                          For estimate only. Estimated prices do not reflect
                          variations due to discounts, traffic delays, or other
                          factors. Actual price may vary. You agree to pay the
                          price shown upon confirming your shipment and/or
                          delivery request. If your route or destination changes
                          on-trip, your price may change based on provided rates
                          and other applicable taxes, tolls, charges, and
                          adjustments. Subject to our Terms of Service.
                        </span>
                      </div>
                    </div>

                    <div className="signUp__wrapper">
                      <Link
                        onClick={() =>
                          window.open(
                            "https://app.wecanrush.com/register",
                            "_blank"
                          )
                        }
                      >
                        <button className="signUp__btn">
                          Sign up and Schedule{" "}
                          <img src={HomeArrow} alt="arrow" />
                        </button>
                      </Link>
                    </div>
                  </form>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="Svg">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path
              fill="#6300FF"
              fill-opacity="1"
              d="M0,320L1440,64L1440,0L0,0Z"
            ></path>
          </svg>
        </div>
        <HomeWork />
        <OurOffer />
        <HomeOfferSlider />
        <ProductCoverd />
        <ProductCoverdSec />
        <AppDownload />
        <Footer />
      </Wrapper>
    </>
  );
};

const Wrapper = styled.section`
  .input_value {
    font-family: Manrope;
  }
  .estimate__tooltip {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .active-color.big-text {
    font-family: Manrope;
    font-style: normal;
    font-weight: 800;
    font-size: 36px;
    line-height: 49px;
    display: flex;
    align-items: center;
    color: #6300ff;
    margin-top: 58px;
    margin-left: 130px;
  }
  .css-1pahdxg-control {
    border: 0;
    outline: none;
    box-shadow: none;
  }

  .css-1pahdxg-control:hover {
    border: 1.5px solid #dbe0eb;
  }

  .css-2b097c-container,
  .css-7pg0cj-a11yText {
    border: 0.5px solid #dbe0eb;
    box-shadow: 0px;
  }

  input::placeholder {
    font-family: Manrope;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: #596278;
  }

  .homemain {
    background: #6300ff;
    width: 100%;
    height: 62vh;
  }
  .Svg {
    margin: -31px 0 142px 0;
  }

  .home__hero.row {
    padding-top: 100px;
  }

  .hero__left {
    margin-left: -16px;
    margin-top: 0;
  }

  .header__vhecel_info {
    padding-top: 25px;
  }

  .hero__delivery_fees {
    width: 281px;
    height: 32px;
    display: flex;
    align-items: center;
    background: rgba(19, 96, 255, 0.8);
    border-radius: 20px;
    button {
      background: #ffffff;
      border-radius: 100px;
      width: 66px;
      height: 22px;
      font-family: Gilroy-Bold;
      font-size: 12px;
      line-height: 14px;
      color: #6300ff;
      border: none;
      outline: none;
      margin-left: 5px;
    }
    h5 {
      font-family: Gilroy-Medium;
      font-size: 12px;
      line-height: 14px;
      color: #ffffff;
      width: 100%;
      height: 15px;
      display: flex;
      align-items: center;
      margin: 0;
      padding-left: 12px;
    }
  }

  .home__hero_left {
    h1 {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 56px;
      line-height: 72px;
      color: #ffffff;
      width: 100%;
      height: 216px;
      margin-top: 32px;
    }
    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 38px;
      color: #ffffff;
      width: 100%;
      height: 76px;
      margin-top: 20px;
    }
  }

  .home__hero_btn {
    display: flex;
    align-items: center;
    margin-top: 45px;
    button {
      background: #ffffff;
      border-radius: 5px;
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: #6300ff;
      width: 232px;
      height: 56px;
      border: none;
      outline: none;
      margin-top: 48px;
      margin-right: 20px;
    }
  }

  .home__hero_btn {
    button:hover {
      background: transparent;
      transition: 0.5s;
      color: #fff;
      border: 1px solid #fff;
    }
  }

  button.header__sececond__btn:hover {
    background: #fff;
    transition: 0.5s;
    color: #6300ff;
  }

  .home__hero_btn2 {
    font-family: Manrope;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    text-align: right;
    color: #ffffff !important;
    background: transparent !important;
    img {
      margin-left: 26.5px;
      margin-right: 8.5px;
    }
  }

  button.home__hero_btn2:hover {
    border: none !important;
  }

  form.sign__up_form {
    position: relative;
    height: 100%;
  }

  .home__right__wrap {
    width: 574px;
    margin: auto;
    height: 670px;
    background: #ffffff;
    border-radius: 20px;
    padding-top: 200px;
    text-align: left;
    padding: 25px 35px;
    z-index: 999;
    position: relative;
    /* transform: translateY(-750px); */
  }
  .sign__Up_hero_wrap {
    background: #e5edfc;
    width: 100vw;
    height: 50rem;
  }

  .Svg {
    margin: sign__Up_hero_wrap;
  }

  .sign__up_method {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 360px;
    margin-top: 40px;
  }

  .sign__up_method a {
    text-decoration: none;
  }

  .sign__up_google {
    background: #6300ff;
    border-radius: 5px;
    width: 212px;
    height: 50px;
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #ffffff;
    display: flex;
    align-items: center;
    img {
      margin-left: 15.6px;
      margin-right: 15.6px;
    }
  }
  .sign__up_social {
    background: #6300ff;
    border-radius: 5px;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    padding-left: 18px;
  }

  form.sign__up_form {
    h1 {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 20px;
      line-height: 27px;
      text-align: center;
      color: #596278;
      margin-top: 26px;
    }
  }
  .sign__up_form h1::before {
    content: "";
    width: 100px;
    height: 2px;
    background: #b6bbc5;
    position: absolute;
    padding: 1px;
    left: 85px;
    top: 12px;
  }
  .sign__up_form h1::after {
    content: "";
    width: 100px;
    height: 2px;
    background: #b6bbc5;
    position: absolute;
    padding: 1px;
    right: 85px;
    top: 12px;
  }
  .signUp__name {
    input {
      background: #ffffff;
      border: 1.5px solid #dbe0eb;
      box-sizing: border-box;
      border-radius: 4px;
      width: 100%;
      height: 45px;
      margin-right: 10px;
      padding-left: 20px;
      outline: none;
      margin-top: 24px;
      font-family: Manrope;
      color: #596278;
    }
  }

  .signUp__process {
    input {
      background: #ffffff;
      border: 1.5px solid #dbe0eb;
      box-sizing: border-box;
      border-radius: 4px;
      width: 100%;
      height: 45px;
      display: block;
      outline: none;
      padding-left: 20px;
    }
  }

  .signup__mail__proc {
    margin-top: 10px;
  }

  button.signUp__btn {
    background: #6300ff;
    border-radius: 5px;
    font-family: Manrope;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
    text-align: center;
    color: #ffffff;
    margin-top: 70px;
    width: 100%;
    height: 50px;
    border: none;
    outline: none;
  }
  p.wrapper__footer {
    font-family: Manrope;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 25px;
    letter-spacing: 0.217059px;
    color: #393f4d;
    margin-top: 41px;
    a {
      text-decoration: none;
      font-family: Manrope;
      font-style: normal;
      /* font-weight: normal; */
      font-size: 18px;
      line-height: 25px;
      letter-spacing: 0.217059px;
      color: #1239ff;
      font-weight: 700;
    }
  }

  .header__vhecel_info {
    select {
      width: 98%;
      margin-top: 75px;
      height: 45px;
      background: #ffffff;
      border: 1.5px solid #dbe0eb;
      box-sizing: border-box;
      border-radius: 4px;
      padding-left: 40px;
      outline: none;
    }
  }

  .tooltips {
    position: relative;
    display: flex;
    justify-content: flex-end;
    margin-top: 53.46px;
    margin-right: 15px;
    filter: drop-shadow(0px 20px 40px rgba(18, 146, 238, 0.1));
    img {
      position: absolute;
    }
  }

  .tooltips .tooltiptext {
    display: none;
    width: 677px;
    height: 147px;
    text-align: left;
    padding: 33px 50px;
    position: absolute;
    z-index: 20;
    /* left: -112px; */
    bottom: 28px;
    margin-bottom: 0;
    margin-left: -60px;
    font-family: Manrope;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    color: #596278;
    background: #ffffff;
    border-radius: 10px;
  }

  .tooltips .tooltiptext::after {
    content: "";
    position: absolute;
    right: 6px;
    bottom: -36px;
    transform: rotate(180deg);
    margin-left: -5px;
    border-width: 20px;
    border-style: solid;
    border-color: transparent transparent #ffffff transparent;
  }

  .tooltips:hover .tooltiptext {
    display: block;
  }

  .signUp__wrapper {
    position: absolute;
    width: 100%;
    bottom: 145px;
  }

  button.signUp__btn:hover {
    background: transparent;
    color: #6300ff;
    border: 1px solid;
    transition: 0.6s;
  }

  @media screen and (max-width: 1300px) {
    .homemain {
      background: #6300ff;
      height: 75vh !important;
      width: 100% !important;
    }

    .signUp__wrapper {
      position: absolute;
      width: 100%;
      bottom: 160px;
    }

    .home__hero_btn {
      display: flex;
      align-items: center;
      margin-top: 45px;

      button {
        background: #ffffff;
        border-radius: 5px;
        font-family: Manrope;
        font-style: normal;
        font-weight: 500;
        font-size: 14px !important;
        line-height: 19px !important;
        color: #6300ff;
        width: 190px !important;
        height: 40px !important;
        border: none;
        outline: none;
        margin-top: 48px;
        margin-right: 4px !important;
      }
    }
  }

  @media screen and (max-width: 768px) {
    /* .homemain {
      background: #6300ff;
      height: 100% !important;
      width: 100% !important;
    } */

    .home__right__wrap {
      width: 100% !important;
      margin: auto;
      height: 643px;
      background: #ffffff;
      border-radius: 20px;
      padding-top: 200px;
      text-align: left;
      padding: 25px 35px;
      z-index: 999;
      /* transform: translateY(-750px); */
    }
  }

  @media screen and (max-width: 440px) {
    .active-color.big-text {
      margin-left: 0;
    }
    .hero__left {
      margin-left: 10px !important;
      margin-top: 0 !important;
    }
    .home__hero_left {
      h1 {
        font-family: Gilroy;
        font-style: normal;
        font-weight: 800;
        font-size: 36px !important;
        line-height: 50px !important;
        color: #ffffff;
        width: 100%;
        height: 150px !important;
        margin-top: 32px;
      }
      p {
        font-family: Manrope;
        font-style: normal;
        font-weight: 500;
        font-size: 16px !important;
        line-height: 38px !important;
        color: #ffffff;
        width: 98% !important;
        height: 60px !important;
        margin-top: 20px;
      }
    }

    .home__hero_btn {
      display: flex;
      align-items: center;
      button {
        background: #ffffff;
        border-radius: 5px;
        font-family: Manrope;
        font-style: normal;
        font-weight: 500;
        font-size: 14px !important;
        line-height: 19px !important;
        color: #6300ff;
        width: 190px !important;
        height: 40px !important;
        border: none;
        outline: none;
        margin-top: 48px;
        margin-right: 4px !important;
      }
    }
    wecanrush .home__hero_btn2 {
      font-family: Manrope;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      display: flex;
      align-items: center;
      text-align: right;
      color: #ffffff !important;
      background: transparent !important;
      img {
        margin-left: 26.5px;
        margin-right: 8.5px;
      }
    }
    button.header__sececond__btn:hover {
      background: #fff;
      transition: 0.5s;
      color: #6300ff;
    }

    .homemain {
      background: #6300ff;
      width: 100%;
      height: 130vh !important;
    }

    .Svg {
      margin: -12px 0 142px 0 !important;
    }

    button.signUp__btn {
      background: #6300ff;
      border-radius: 5px;
      font-family: Manrope;
      font-style: normal;
      font-weight: 600;
      font-size: 14px !important;
      line-height: 19px !important;
      text-align: center;
      color: #ffffff;
      margin-top: 70px;
      width: 100%;
      height: 35px !important;
      border: none;
      outline: none;
      margin-top: 0 !important;
    }

    .hone__right__form {
      transform: translateY(120px);
    }

    .sign__up_form h1::before {
      content: "";
      width: 100px;
      height: 2px;
      background: #b6bbc5;
      position: absolute;
      padding: 1px;
      left: 0 !important;
      top: 12px !important;
    }
    .sign__up_form h1::after {
      content: "";
      width: 100px;
      height: 2px;
      background: #b6bbc5;
      position: absolute;
      padding: 1px;
      right: 0px !important;
      top: 12px !important;
    }

    .tooltips {
      position: relative;
      display: flex;
      justify-content: flex-end;
      margin-top: 53.46px;
      margin-right: 15px;
      filter: drop-shadow(0px 20px 40px rgba(18, 146, 238, 0.1));
      img {
        position: absolute;
      }
    }

    .tooltips .tooltiptext {
      display: none;
      width: 356px;
      height: 230px !important;
      text-align: left;
      padding: 33px 22px !important;
      position: absolute;
      z-index: 20;
      bottom: 28px;
      margin-bottom: 0;
      margin-left: -60px;
      font-family: Manrope;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 20px;
      color: #596278;
      background: #ffffff;
      border-radius: 10px;
      right: -22px !important;
    }

    .tooltips .tooltiptext::after {
      content: "";
      position: absolute;
      right: 15px !important;
      bottom: -36px;
      transform: rotate(180deg);
      margin-left: -5px;
      border-width: 20px;
      border-style: solid;
      border-color: transparent transparent #ffffff transparent;
    }

    .tooltips:hover .tooltiptext {
      display: block;
    }
  }

  @media screen and (max-width: 414px) {
    .active-color.big-text {
      margin-left: 0;
    }
    .hero__left {
      margin-left: 10px !important;
      margin-top: 0 !important;
    }
    .home__hero_left {
      h1 {
        font-family: Gilroy;
        font-style: normal;
        font-weight: 800;
        font-size: 36px !important;
        line-height: 50px !important;
        color: #ffffff;
        width: 100%;
        height: 150px !important;
        margin-top: 32px;
      }
      p {
        font-family: Manrope;
        font-style: normal;
        font-weight: 500;
        font-size: 16px !important;
        line-height: 38px !important;
        color: #ffffff;
        width: 98% !important;
        height: 60px !important;
        margin-top: 20px;
      }
    }

    .home__hero_btn {
      display: flex;
      align-items: center;
      button {
        background: #ffffff;
        border-radius: 5px;
        font-family: Manrope;
        font-style: normal;
        font-weight: 500;
        font-size: 14px !important;
        line-height: 19px !important;
        color: #6300ff;
        width: 190px !important;
        height: 40px !important;
        border: none;
        outline: none;
        margin-top: 48px;
        margin-right: 4px !important;
      }
    }
    wecanrush .home__hero_btn2 {
      font-family: Manrope;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      display: flex;
      align-items: center;
      text-align: right;
      color: #ffffff !important;
      background: transparent !important;
      img {
        margin-left: 26.5px;
        margin-right: 8.5px;
      }
    }
    button.header__sececond__btn:hover {
      background: #fff;
      transition: 0.5s;
      color: #6300ff;
    }

    .homemain {
      background: #6300ff;
      width: 100%;
      height: 130vh !important;
    }

    .Svg {
      margin: -12px 0 142px 0 !important;
    }

    button.signUp__btn {
      background: #6300ff;
      border-radius: 5px;
      font-family: Manrope;
      font-style: normal;
      font-weight: 600;
      font-size: 14px !important;
      line-height: 19px !important;
      text-align: center;
      color: #ffffff;
      margin-top: 70px;
      width: 100%;
      height: 35px !important;
      border: none;
      outline: none;
      margin-top: 0 !important;
    }

    .hone__right__form {
      transform: translateY(120px);
    }

    .sign__up_form h1::before {
      content: "";
      width: 100px;
      height: 2px;
      background: #b6bbc5;
      position: absolute;
      padding: 1px;
      left: 0 !important;
      top: 12px !important;
    }
    .sign__up_form h1::after {
      content: "";
      width: 100px;
      height: 2px;
      background: #b6bbc5;
      position: absolute;
      padding: 1px;
      right: 0px !important;
      top: 12px !important;
    }

    .tooltips {
      position: relative;
      display: flex;
      justify-content: flex-end;
      margin-top: 53.46px;
      margin-right: 15px;
      filter: drop-shadow(0px 20px 40px rgba(18, 146, 238, 0.1));
      img {
        position: absolute;
      }
    }

    .tooltips .tooltiptext {
      display: none;
      width: 356px;
      height: 230px !important;
      text-align: left;
      padding: 33px 22px !important;
      position: absolute;
      z-index: 20;
      bottom: 28px;
      margin-bottom: 0;
      margin-left: -60px;
      font-family: Manrope;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 20px;
      color: #596278;
      background: #ffffff;
      border-radius: 10px;
      right: -22px !important;
    }

    .tooltips .tooltiptext::after {
      content: "";
      position: absolute;
      right: 15px !important;
      bottom: -36px;
      transform: rotate(180deg);
      margin-left: -5px;
      border-width: 20px;
      border-style: solid;
      border-color: transparent transparent #ffffff transparent;
    }

    .tooltips:hover .tooltiptext {
      display: block;
    }
  }
`;

export default HomePage;
